import confirmDialog from 'src/vuex/modules/confirm-dialog'
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import etp from '../modules/assets/etp/store'
import auth from '../modules/auth/store'
import authorization from '../modules/authorization/store'
import accountStatements from '../modules/investors/account-statements/store'
import positions from '../modules/investors/positions/store'
import pricing from '../modules/investors/pricing/store'
import strategies from '../modules/investors/strategies/store'
import bots from '../modules/market/bots/store'
import matching from '../modules/matching/store'
import partners from '../modules/partners/store'
import partnerPricing from '../modules/pricing/store'
import invoice from '../modules/requests/invoice/store'
import payables from '../modules/requests/payables/store'
import settlementLock from '../modules/settlement-lock/store'
import navigation from './modules/navigation'
import snackbar from './modules/snackbar'
import spinner from './modules/spinner'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const plugins = []
if (debug) {
  plugins.push(createLogger())
}

const store = new Vuex.Store({
  modules: {
    auth,
    authorization,
    bots,
    confirmDialog,
    invoice,
    navigation,
    pricing,
    positions,
    accountStatements,
    settlementLock,
    snackbar,
    spinner,
    strategies,
    partners,
    etp,
    payables,
    partnerPricing,
    matching
  },
  strict: debug,
  plugins
})

export default store
